export enum FLOATING_MENU_LINK_TYPES {
  GENERAL_LINK = 'Floating Menu Link',
  CONTACT_US = 'Generic Popup Link',
  BUILD_AND_PRICE = 'Build And Price Link',
}
